import { Route, BrowserRouter, Switch, Redirect } from 'react-router-dom';
import { useReducer, createContext } from 'react';
import SimpleReactLightbox from "simple-react-lightbox";
import Login from './../components/Login';
import Index from './../components/Index';
import jwt from 'jwt-decode'
import swal from 'sweetalert'
import FeedbackWA from '../components/Content/Feedback/Feedback';

export const AuthContext = createContext();

const App = () => {
  const initialState = {
    isAuthenticated: false,
    page: (localStorage.getItem('token-helpdesk-umy')) ? Number.isInteger(jwt(localStorage.getItem('token-helpdesk-umy')).role_id) ? 'Dashboard' : 'Message' : 'Dashboard',
    message: null,
  }

  const reducer = (state, action) => {
    switch (action.type) {
      case "LOGIN":
        localStorage.setItem('token-helpdesk-umy', action.payload.token)
        return {
          ...state,
          isAuthenticated: true,
        }
      case "LOGOUT":
        localStorage.removeItem('token-helpdesk-umy')

        if (action.message != null) {
          swal("Error!", `${action.message}`, "error", {
            button: "OK",
          });
        }
        return {
          ...state,
          isAuthenticated: false,
          message: action.message
        }
      case "PATH":
        return {
          ...state,
          page: action.page,
        }
      default:
        return state
    }
  }

  const [stateAuth, dispatchAuth] = useReducer(reducer, initialState)
  return (

    <BrowserRouter>
      <Switch>
        <Route exact path="/feedback" component={FeedbackWA} />
        <AuthContext.Provider value={{ stateAuth, dispatchAuth }}>
          <Route exact path="/">
            <Redirect to="/index" />
          </Route>
          <Route exact path="/login" component={Login}></Route>
          <SimpleReactLightbox>
            <Route exact path="/index" component={Index}></Route>
          </SimpleReactLightbox>
        </AuthContext.Provider>
      </Switch>
    </BrowserRouter>
  );
}

export default App;
